import type { UserRole } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useInfiniteQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

type UserListParams = {
  isDeleted?: boolean
  isHidden?: boolean
  isCursorPaginationEnabled?: boolean
  limit?: number
  cursor?: string
  roles?: UserRole[]
  isActive?: boolean
  sites?: string[]
  searchByName?: string
}

type UseUsersListProps = {
  params?: UserListParams
  enabled?: boolean
}

const USERS_URL = '/api/list/carers'

const useUsersInfiniteList = ({ params, enabled }: UseUsersListProps) => {
  const fetchUsers = async ({ pageParam = '' }) => {
    const queryParams = getQueryParams({ ...params, cursor: pageParam })

    const response = await getJSON({
      url: `${USERS_URL}?${queryParams}`
    })

    return {
      users: response.data,
      cursor: response.pagination.cursor || null
    }
  }

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery(
      [
        'users',
        params?.limit,
        params?.roles,
        params?.isActive,
        params?.sites,
        params?.searchByName
      ],
      fetchUsers,
      {
        getNextPageParam: (lastPage) => lastPage.cursor || undefined,
        enabled
      }
    )

  const users = data?.pages.flatMap((page) => page.users) || []

  return {
    users,
    isLoading,
    fetchNextPage,
    hasNextPage: !!hasNextPage,
    isFetchingNextPage
  }
}

export default useUsersInfiniteList
